module.exports = __webpack_public_path__ + "static/media/artwork.40f33e39.jpg";